import { useState, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import GalleryLightbox from './GalleryLightbox.jsx';
import { SERVICE_WORK_CARDS } from '../data/serviceWork.js';

export default function ServicesSection({ titleTag: Title = 'h2' }) {
  const [lightbox, setLightbox] = useState(null);

  const closeLightbox = useCallback(() => setLightbox(null), []);

  const navigateTo = useCallback((i) => {
    setLightbox((prev) => {
      if (!prev || prev.slides.length === 0) return prev;
      const len = prev.slides.length;
      const wrapped = ((i % len) + len) % len;
      return { ...prev, index: wrapped };
    });
  }, []);

  const openWork = useCallback((cardIndex) => {
    const card = SERVICE_WORK_CARDS[cardIndex];
    if (!card?.workSlides?.length) return;
    setLightbox({ slides: card.workSlides, index: 0, title: card.title });
  }, []);

  const lightboxAria = useMemo(() => {
    if (!lightbox?.title) return 'Example project photos';
    return `Example work: ${lightbox.title}`;
  }, [lightbox?.title]);

  return (
    <section id="services" className="section services">
      <div className="container">
        <Title>What we do</Title>
        <p className="section-intro services-cards-intro">
          Use <strong>Show example work</strong> on any service to open before, after, and finished
          photos for that category.
        </p>
        <ul className="service-grid service-grid--work-cards">
          {SERVICE_WORK_CARDS.map((card, i) => (
            <li key={card.id}>
              <div className="service-work-card">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
                <button
                  type="button"
                  className="btn btn-outline service-examples-btn"
                  onClick={() => openWork(i)}
                  aria-haspopup="dialog"
                  aria-label={`Show example work for ${card.title}`}
                >
                  Show example work
                </button>
              </div>
            </li>
          ))}
        </ul>
        <p className="services-quote-cta">
          <strong>We’re booking services now.</strong> Call or message us for a free quote—no obligation.
          <Link className="btn btn-primary" to="/contact">
            Get your free quote
          </Link>
        </p>
      </div>
      {lightbox != null && lightbox.slides.length > 0 ? (
        <GalleryLightbox
          slides={lightbox.slides}
          index={lightbox.index}
          onClose={closeLightbox}
          onNavigate={navigateTo}
          ariaLabel={lightboxAria}
        />
      ) : null}
    </section>
  );
}
